export const PENDING_QUICK_CLARITY_KEY = "ahavibes_pending_quick_clarity";
export const QUICK_CLARITY_LOGIN_INTENT = "quick-clarity";

export function setPendingQuickClarity(text) {
  try {
    sessionStorage.setItem(PENDING_QUICK_CLARITY_KEY, String(text || "").trim());
  } catch (_) {
    /* ignore quota / private mode */
  }
}

export function getPendingQuickClarity() {
  try {
    return sessionStorage.getItem(PENDING_QUICK_CLARITY_KEY) || "";
  } catch (_) {
    return "";
  }
}

export function clearPendingQuickClarity() {
  try {
    sessionStorage.removeItem(PENDING_QUICK_CLARITY_KEY);
  } catch (_) {
    /* ignore */
  }
}

export function hasPendingQuickClarity() {
  return Boolean(getPendingQuickClarity().trim());
}
